import { render, staticRenderFns } from "./list_bak.vue?vue&type=template&id=7bc9d7de"
import script from "./list_bak.vue?vue&type=script&lang=js"
export * from "./list_bak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports